import { Form, Input, Switch } from 'antd';
import React, { Fragment, useCallback, useMemo, useState } from 'react';
import useDebouncedSearch from '../../../../../../hooks/useDebouncedSearch';
import useDadataAddresses from '../../../../queries/useDadataAddresses';
import { emailValidator, phoneValidator } from '../../../../utils/validators';
import styles from '../../modalStyles.module.scss';
import AddressSelect from '../AddressSelect/AddressSelect';
import CountrySelect from '../CountrySelect/CountrySelect';
import ReceiptSelect from '../ReceiptSelect/ReceiptSelect';

const ContractorModalOrganisationMode = ({
  getFieldDecorator,
  getOptions,
  getFieldValue,
  editingCounterparty,
  setFieldsValue,
}) => {
  const initialLegalIsActualAddress = useMemo(() => {
    if (editingCounterparty?.actualAddress) {
      const actualAddress = editingCounterparty?.actualAddress.fullAddress;
      const registrationAddress =
        editingCounterparty?.registrationAddress?.fullAddress;

      if (actualAddress && actualAddress === registrationAddress) {
        return true;
      }
      return false;
    }
    return false;
  }, [editingCounterparty]);

  const [legalIsActualAddress, setLegalIsActualAddress] = useState(
    initialLegalIsActualAddress
  );

  const [_search, setSearch, debouncedSearch] = useDebouncedSearch();
  const [
    _actualAddressSearch,
    setActualAddressSearch,
    debouncedActualAddressSearch,
  ] = useDebouncedSearch();

  const { data: dadataAddresses, isFetching: dadataAddressesLoading } =
    useDadataAddresses(debouncedSearch);
  const {
    data: dadataActualAddresses,
    isFetching: dadataActualAddressesLoading,
  } = useDadataAddresses(debouncedActualAddressSearch);

  const onLegalIsActualAddressChange = useCallback(
    () =>
      setLegalIsActualAddress((legalIsActualAddress) => !legalIsActualAddress),
    []
  );

  return (
    <>
      <Form.Item label="Наименование" className={styles.flexFull}>
        {getFieldDecorator('name', {
          initialValue: editingCounterparty?.name,
          ...getOptions('Введите название организации.'),
        })(<Input placeholder="Введите текст" />)}
      </Form.Item>
      <div className={styles.flex}>
        <Form.Item label="Фамилия" className={styles.flexFull}>
          {getFieldDecorator('surName', {
            initialValue: editingCounterparty?.surName,
            ...getOptions('Введите фамилию.'),
          })(<Input placeholder="Введите текст" />)}
        </Form.Item>
        <Form.Item label="Имя" className={styles.flexFull}>
          {getFieldDecorator('firstName', {
            initialValue: editingCounterparty?.firstName,
            ...getOptions('Введите имя.'),
          })(<Input placeholder="Введите текст" />)}
        </Form.Item>
        <Form.Item label="Отчество" className={styles.flexFull}>
          {getFieldDecorator('patrName', {
            initialValue: editingCounterparty?.patrName,
          })(<Input placeholder="Введите текст" />)}
        </Form.Item>
      </div>
      <div className={styles.flex}>
        <Form.Item label="Почта" className={styles.flexFull}>
          {getFieldDecorator('email', {
            initialValue: editingCounterparty?.email,
            rules: [
              {
                validator: emailValidator,
              },
            ],
          })(<Input placeholder="Введите почту" />)}
        </Form.Item>
        <Form.Item label="Телефон" className={styles.flexFull}>
          {getFieldDecorator('phoneNumber', {
            initialValue: editingCounterparty?.phoneNumber,
            rules: [
              {
                validator: phoneValidator,
              },
            ],
          })(<Input placeholder="+79876543210" />)}
        </Form.Item>
      </div>

      <div className={styles.flex}>
        <Form.Item label="ИНН" className={styles.flexFull}>
          {getFieldDecorator('INN', {
            initialValue: editingCounterparty?.legalEntityInfo?.inn,
          })(<Input placeholder="Введите номер" />)}
        </Form.Item>
        <Form.Item label="ОГРН" className={styles.flexFull}>
          {getFieldDecorator('OGRN', {
            initialValue: editingCounterparty?.legalEntityInfo?.ogrn,
          })(<Input placeholder="Введите номер" />)}
        </Form.Item>
      </div>

      <div className={styles.flex}>
        <CountrySelect
          className={styles.flexFull}
          editingCounterparty={editingCounterparty}
          getFieldDecorator={getFieldDecorator}
        />
        <Form.Item label="КПП" className={styles.flexFull}>
          {getFieldDecorator('KPP', {
            initialValue: editingCounterparty?.legalEntityInfo?.kpp,
          })(<Input placeholder="Введите номер" />)}
        </Form.Item>
      </div>

      <Form.Item label="ОКПО">
        {getFieldDecorator('OKP', {
          initialValue: editingCounterparty?.legalEntityInfo?.okp,
        })(<Input placeholder="Введите номер" />)}
      </Form.Item>
      <ReceiptSelect
        getFieldDecorator={getFieldDecorator}
        editingCounterparty={editingCounterparty}
        getOptions={getOptions}
      />
      {getFieldDecorator('registrationAddress', {
        preserve: true,
        initialValue: editingCounterparty?.registrationAddress,
      })(<Fragment />)}

      <AddressSelect
        placeholder="Введите город и улицу"
        defaultValue={editingCounterparty?.registrationAddress}
        addresses={[
          ...dadataAddresses,
          editingCounterparty?.registrationAddress,
        ].filter(Boolean)}
        setSearch={setSearch}
        loading={dadataAddressesLoading}
        formKey="registrationAddress"
        setFieldsValue={setFieldsValue}
        getFieldValue={getFieldValue}
        label="Юридический адрес"
        nameKey={'fullAddress'}
      />
      <div className={styles.toggleContainer}>
        <div className={styles.toggle} onClick={onLegalIsActualAddressChange}>
          <Switch className={styles.switch} checked={legalIsActualAddress} />
          Совпадает с юр.адресом
        </div>
        {getFieldDecorator('actualAddress', {
          preserve: true,
          initialValue: editingCounterparty?.actualAddress,
        })(<Fragment />)}
        <AddressSelect
          placeholder="Введите город и улицу"
          defaultValue={editingCounterparty?.actualAddress}
          addresses={[
            ...dadataActualAddresses,
            editingCounterparty?.actualAddress,
          ].filter(Boolean)}
          setSearch={setActualAddressSearch}
          loading={dadataActualAddressesLoading}
          getFieldValue={getFieldValue}
          nameKey={'fullAddress'}
          valueFromLegalAddress={legalIsActualAddress}
          setFieldsValue={setFieldsValue}
          label="Фактический адрес"
          formKey="actualAddress"
        />
      </div>
    </>
  );
};

export default ContractorModalOrganisationMode;
